import { loadReCaptchaScript, removeReCaptchaScript } from '@/helpers/captcha';
import env from '@/providers/env';
import { FC, useCallback, useEffect, useRef, useState } from 'react';

const idScript = 'captcha-v2';

const Recaptcha: FC<ReCaptchaV2.Parameters> = ({ type, ...rest }) => {
  const [montado, setMontado] = useState(false);
  const captchaContainer = useRef(null);

  const handleRecaptchaLoad = useCallback(async () => {
    try {
      // Añado script al documento
      await loadReCaptchaScript(env?.RECAPTCHA.SCRIPT, idScript, () => {
        if (captchaContainer.current) {
          // Renderizar widget de recaptcha
          window.grecaptcha.ready(async () => {
            window.grecaptcha.render(captchaContainer.current, {
              sitekey: env?.RECAPTCHA?.KEY_V2,
              ...rest,
            });
          });
        }
      });
    } catch (error) {
      console.log(error);
    }
  }, [rest]);

  useEffect(() => {
    if (!montado) return setMontado(true);

    // Cargo el widget cuando se monta
    handleRecaptchaLoad();

    // Eliminar el script al desmontar el componente
    return () => {
      removeReCaptchaScript(idScript);
    };
  }, [handleRecaptchaLoad, montado]);

  return <div id='recaptcha-container' ref={captchaContainer} />;
};

export default Recaptcha;
